import axios from "axios";
export class ItineraryService {
    static getItinerary(itineraryId) {
        return axios.get(`/api/itineraries/${itineraryId}`)
            .then(data => {
            return data.data;
        });
    }
}
